import { Component, Input, Output, OnDestroy, EventEmitter, OnInit, HostListener } from "@angular/core";
import { ServiceModelManagerServices } from "../../services/service-model-manager.services";
import { MongoVideoServices } from "../../services/mongoVideo.services";
import { MongoImageServices } from "../../services/mongoImage.services";
import { DocumentModel } from "../../models/document.model";

@Component({
  selector:  'app-filter-tabs',
  template: require('./app-filter-tabs.component.pug'),
  styles: [require('./app-filter-tabs.component.scss')]
})

export class AppFilterTabs implements OnInit, OnDestroy {
  private activeService: any;
  private modelSubscription: any;
  private termsSubscription: any;
  private viewSubscription: any;

  private tabs: DocumentModel = new DocumentModel();
  private keys: any;

  constructor(
    private service: ServiceModelManagerServices,
    private videos: MongoVideoServices,
    private images: MongoImageServices,
  ) {
  }

  ngOnInit(): void {
    this.keys = Object.keys(this.tabs);

    this.modelSubscription = this.service.serviceReady.subscribe( ( service: any )  => {
      this.activeService = service;
    })

    this.termsSubscription = this[this.activeService].onUpdatedSearchTerms.subscribe( (updatedTerms: any ) => {
      if ( updatedTerms ) {
        const { terms, isSearch } = updatedTerms;
        if ( isSearch ) {
          this.tabs.clear();
          terms.forEach( (element: any) => {
            if ( element ) {
              const { queryTerm, title } = element;
              const key = queryTerm.split('.').pop();
              !this.tabs[key].value ? this.tabs[key].value = [] : this.tabs[key].value.push(title);
            }
          });
        }
      }
    })

    this.viewSubscription  = this[this.activeService].onUpdatedView.subscribe( (updatedView: any) => {
      if ( updatedView ) {
        const { isSearch, videos, images } = updatedView;
        const thisService = this[this.activeService];
      }
    })

  }

  ngOnDestroy(): void {
    this.modelSubscription.unsubscribe();
    this.viewSubscription.unsubscribe();
  }

  @HostListener( 'click', ['$event']) removeItemFromFilter(e : Event) {
    if ( e ) {
      const { id } = e.srcElement;
      const thisService = this[this.activeService];
      thisService.latestSearch.set({ $nor: id });
      thisService.search( thisService.latestSearch );
    }
  }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/components/app-filter-tabs/app-filter-tabs.component.ts